import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogPassConfirmComponent } from 'app/components/dialog-pass-confirm/dialog-pass-confirm.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogPassConfirmService {

  constructor(private dialog: MatDialog) { }

  openDialog(data: any): Observable<boolean> {
    const dialogRef = this.dialog.open(DialogPassConfirmComponent, {
      data: data,
    });

    return dialogRef.afterClosed();
  }
}
